function fromCamelCase (key) {
  const result = ('' + key)
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/_/g, ' ')
    .replace(/([a-z])([0-9])/gi, '$1 $2')
    .replace(/([0-9])([a-z])/gi, '$1 $2')
  return result.charAt(0).toUpperCase() + result.slice(1)
}

export default fromCamelCase



// WEBPACK FOOTER //
// ./src/lib/fromCamelCase.js